import script from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./ClientInfoModal.vue?vue&type=style&index=0&id=6352a276&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6352a276"]])

export default __exports__